<ng-container *ngIf="(isOffersLoading$ | async) === false; then grid; else preloader"></ng-container>
<ng-template #grid>
  <div class="container text-center" *ngIf="departureCitiesMessage$ | async as message">
    <p role="status">{{ ('TourOffersPage.' + message) | translate }}</p>
    <button class="btn btn-primary" type="button"
            *ngIf="message === 'DepartureCitiesLoadingFailure'"
            (click)="retryDepartureCities()">
      {{ 'TourOffersPage.RetryDepartureCities' | translate }}
    </button>
  </div>
  <div class="container" *ngIf="hotels$ | async as hotels">
    <ng-container *ngIf="{ isLoading: isSearchContinuationLoading$ | async, isSorting: isSorting$ | async } as state">
      <div class="tour-offers-content__results-loader" *ngIf="hotels.length > 0 && (state.isLoading || state.isSorting)">
        <app-bus-preloader></app-bus-preloader>
      </div>
      <div
        class="tour-offers-content__grid"
        [class.tour-offers-content__grid_disabled]="state.isSorting">
        <app-offers-grid [hotels]="hotels">
          <ng-container *ngIf="!state.isLoading && !state.isSorting">
            <app-load-more-button
              *ngIf="hasNext$ | async"
              [loadingMsg]="('TourOffersPage.LoadMore.Loading' | translate)!"
              [loadMoreMsg]="('TourOffersPage.LoadMore.Static' | translate)!"
              [isLoading]="(isNextPageLoading$ | async)!"
              (click)="loadNextPage()">
            </app-load-more-button>
          </ng-container>
        </app-offers-grid>
      </div>
    </ng-container>
  </div>
</ng-template>
<ng-template #preloader>
  <div class="container">
    <app-bus-preloader class="row"></app-bus-preloader>
  </div>
</ng-template>
